module.exports = __webpack_public_path__ + "static/media/start-time-attendance.8743f665.svg";